module.exports = __webpack_public_path__ + "img/bcr.bebb5dd8.svg";